export const getUsersForTable = (state) => state.users.list;
export const getSelectedUser = (state) => state.users.selectedUser;
export const getUserValidProjects = (state) => {
  const entityProjects = state.users.entityProjects;
  const userProjects = state.users.selectedUser.selectedProjects;
  const validProjects = userProjects ? userProjects.filter(p => entityProjects.some(pr => pr.project_id === p.project_id)) : []
  return validProjects
};
export const getProjectsForEntity = (state) => state.users.entityProjects || [];
export const getSurveyLeaders = (state) => state.users.leaders;